import common from './common';

const homeDomain = 'customer.dev.xfinity.com';
const mobileDomain = 'mcx-staging.dss-ops.xfinity.com/mobile';
const paymentDomain = 'payments.dev.xfinity.com';

const CONFIG = {
  ...common,
  homeDomain,
  mobileDomain,
  billServicesUrl: `https://${homeDomain}/billing/services`,
  billingUrl: `https://${homeDomain}/billing`,
  billingMobileUrl: `https://${homeDomain}/billing/mobile`,
  billingMobileTransactionsUrl: `https://${homeDomain}/billing/mobile/transactions`,
  makePaymentUrl: `https://${paymentDomain}/new`,
  cwaRoot: 'https://staging-static.cimcontent.net/common-web-assets/',
  paymentSetup: {
    ...common.paymentSetup,
    // Where to go if no continueUrl specified (from consent flow)
    defaultContinue: `https://${homeDomain}/`,
  },
  firebaseEnabled: true,
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/staging/featureFlagsStaging.json',
  shelbyCMSUrl: 'https://sdx.qa.xfinity.com/cms/data/',
  oauthUrl: 'https://oauth-st.xfinity.com',
  collectionsBack: 'https://www.stg.xfinity.com/buy/plan/xap',
  nowMobileUrl: `https://${mobileDomain}/my-account/now/activity`,
  xmMyAccountUrl: `https://${mobileDomain}/my-account`,
  devicesMobileUrl: `https://${mobileDomain}/my-account/devices`,
};

export default CONFIG;
